import i18next from 'i18next';

i18next.addResources('es', 'DateRangeFilter', {
  label: '{{from}} al {{to}}'
});
